import module0 from '../plugins/react-app/pluginRuntime/runtime';
import module1 from '../plugins/router/pluginRuntime/runtime';

interface IRuntime<T> {
  loadModule: (module: { default: T } | T) => void;
}

function loadRuntimeModules(runtime: IRuntime<Function>) {
  runtime.loadModule(module0);
  runtime.loadModule(module1);
}

export default loadRuntimeModules;
